var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['cf-c-cube-tag', _vm.wrapperClasses]},[_c('span',{staticClass:"cf-c-cube-tag__label"},[_vm._t("label")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }